export default __webpack_public_path__ + "static/media/team.e3218132.png";